/*
 * Copyright 2019 Teralytics
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
export default "#define SHADER_NAME flow-circles-layer-fragment-shader\n#define SOFT_OUTLINE 0.1\nprecision highp float;\n\nvarying vec4 vColor;\nvarying vec2 unitPosition;\nvarying float outerRadiusPixels;\n\nvoid main(void) {\n  geometry.uv = unitPosition;\n  float distToCenter = length(unitPosition);\n  if (distToCenter > 1.0) {\n    discard;\n  }\n  gl_FragColor = vColor;\n  gl_FragColor.a *= smoothstep(0.0, SOFT_OUTLINE, 1.0 - distToCenter);\n  DECKGL_FILTER_COLOR(gl_FragColor, geometry);\n}\n";
//# sourceMappingURL=FlowCirclesLayerFragment.glsl.js.map